import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep6 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/analytics') {
      this.props.history.push('/analytics');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 6});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 5});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Analytics page
        </h2>
        <p>
          Here you can see all the latest transactions, token mints along with richest people in ASC. Also there are
          links to Etherscan transactions.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep6);


// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep6.js